import api from "./axios";

export const createProject = (data) => api.post("/projects", data);
export const deleteProject = (id) => api.delete(`/projects/${id}`);
export const getProjects = (options = {}) => {
  const params = {};
  if (options.includeArchived) params.includeArchived = "1";
  return api.get("/projects/all", { params });
};

/**
 * Project list for user assignment (Edit User / Pending Approval).
 * Ignores the sidebar department filter; scopes to the selected department.
 */
export const getProjectsForAssignment = ({ department } = {}) => {
  const params = { strictDepartment: "1" };
  if (department) {
    params.departmentView = department;
  }
  return api.get("/projects/all", { skipDepartmentView: true, params });
};
export const getMyProjects = () => api.get("/projects/my-projects");
export const getProjectById = (id) => api.get(`/projects/${id}`);
export const getProjectStats = (id) => api.get(`/projects/${id}/insights`);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
/** Legacy helper used by BudgetEditor — updates `budgetused` only. */
export const updateBudget = (projectId, budgetused) =>
  updateProject(projectId, { budgetused: Number(budgetused) });
export const assignMemberToProject = (project_id, user_id, role_in_project = 'owner') =>
  api.post("/projects/assign", { project_id, user_id, role_in_project });
export const getProjectInsights = (id) => api.get(`/projects/${id}/insights`);

const pid = (id) => encodeURIComponent(String(id));

export const getBudgetLines = (projectId) => api.get(`/projects/${pid(projectId)}/budget-lines`);
export const getBudgetRollup = (projectId, year, organizationView) =>
  api.get(`/projects/${pid(projectId)}/budget-lines/rollup`, {
    params: {
      ...(year ? { year } : {}),
      ...(organizationView ? { organizationView } : {}),
    },
  });
export const createBudgetLine = (projectId, data) => api.post(`/projects/${pid(projectId)}/budget-lines`, data);
export const updateBudgetLine = (projectId, lineId, data) =>
  api.put(`/projects/${pid(projectId)}/budget-lines/${encodeURIComponent(String(lineId))}`, data);
export const updateBudgetLinePaymentStatus = (projectId, lineId, payment_status) =>
  api.patch(
    `/projects/${pid(projectId)}/budget-lines/${encodeURIComponent(String(lineId))}/payment-status`,
    { payment_status }
  );
export const deleteBudgetLine = (projectId, lineId) =>
  api.delete(`/projects/${pid(projectId)}/budget-lines/${encodeURIComponent(String(lineId))}`);
